import moment from 'moment';

export function getFormattedShortDate(date: Date): string {
  return moment(date).format("YYYY/MM/DD");
}

export function getFormattedLongDate(date: Date): string {
  return moment(date).format("YYYY/MM/DD hh:mm A");
}

var hex: string[] = [];
for (var i = 0; i < 16; i++) {
  hex[i] = (i).toString(16);
}

export function createRandomUUID(): string {
  var pattern = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
  var result = ""
  for (var i = 0; i < pattern.length; i++) {
    if (pattern[i] === 'x') {
      result += hex[Math.random() * 16 | 0x0];
    } else if (pattern[i] === 'y') {
      result += hex[Math.random() * 16 | 0x8];
    } else {
      result += pattern[i];
    }
  }
  return result;
}

export function isAndroidMobile(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }

  const uaData = (navigator as any).userAgentData;
  if (uaData && typeof uaData.platform === 'string') {
    return uaData.platform.toLowerCase() === 'android' && uaData.mobile === true;
  }

  const ua = navigator.userAgent || '';
  return /Android/i.test(ua) && /Mobile/i.test(ua);
}
